
<template>
  
    <card>
      <h4 slot="header" class="card-title">Arşiv</h4>
      <table class="table table-hover table-striped table-bordered mb-0">
        <caption >Toplam: {{total}}</caption>
        <thead class="thead-dark">
          <th>Başlık</th>
          <th>Tarih</th>
          <th>Okunma Sayısı</th>
          <th style="width:15%">İşlemler</th>
        </thead>
        <tbody>
          <tr v-for="item in table" :key="item.id">
            <td>{{item.title}}</td>
            <td>{{item.timestamp | moment("Do/MM/YYYY HH:mm:ss")}}</td>
            <td>{{item.hits}}</td>
            <td>
              <router-link :to="{ path: 'archive/edit/'+item.id}" v-b-tooltip title="Düzenle" class="btn btn-primary btn-fill btn-xs" tag="li"><i class="fas fa-edit"></i></router-link>
              <button v-b-tooltip title="Sil" v-on:click="deactivate(item.id)" class="btn btn-danger btn-fill btn-xs"><i class="fas fa-times"></i></button>
            </td>
          </tr>
        </tbody>
      </table>
      <nav aria-label="Page navigation small">

        <ul class="pagination justify-content-end">
          <li class="page-item" v-bind:class="{disabled: isFirst()}"><a class="page-link" v-on:click="getPosts(page - 1,type)" >Öncesi</a></li>
          <li class="page-item" v-for="current in pageCount" v-if="isInScope(current)" v-bind:class="{active: isActive(current), 'mr-2': current == 1, 'ml-2': current == pageCount.length}" :key="current"><a href="javascript:void(0)" class="page-link active" v-on:click="getPosts(current,type)">{{current}}</a></li>
          <li class="page-item" v-bind:class="{disabled: isLast()}"><a class="page-link" v-on:click="getPosts(page + 1,type)">Sonrası</a></li>
        </ul>
      </nav>


    </card>

</template>
<script>
  import Card from 'src/components/UIComponents/Cards/Card.vue'


  export default {
    data: function () {
      return {
        post: {
          siralama:null
        },
        table: null,
        total: 0,
        limit: localStorage.getItem('filterLimit'),
        page: 1,
        pageCount: null,
        navigation: true,
        type: 'all',
        viewCounts: []
      }
    },
    components: {
      Card
    },

    methods: {
      deactivate: function(id){
        this.toggleLoader()
        this.post.sure = 999999
        this.$http.post('/api/archive/edit/' + id, this.post).then(
          response => {
            this.notifier('top', 'right', 'warning', 'Silindi')
            this.getPosts(this.page,this.type)
            this.toggleLoader()
          },
          e => {
            this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            this.toggleLoader()
          })
      },
      isInScope: function(c){
        if(c === 1){
          return true
        }
        if(c === this.pageCount.length){
          return true
        }
        if(c - this.page > 3 || this.page - c > 3){
          return false;
        }
        return true
      },
      isActive: function (v) {
        return v === this.page
      },
      isFirst: function () {
        return this.page === 1
      },
      isLast: function () {
        return this.page === Math.ceil(this.total / this.limit)
      },
      getPosts: function (p = 1, t = 'all') {
        this.toggleLoader()
        this.type = t
        var url = '/api/filter/archive/exclude/sure:999999/limit/' + this.limit + '/page/' + p
        this.$http
        .get(url)
        .then(
          response => {

            this.table = response.body.data
            this.total = response.body.meta.total
            this.page = p
            this.pageCount = []
            for (var i = 0; i < this.total / this.limit; i++) {
              this.pageCount.push(i + 1)
            }
            this.toggleLoader()
          },
          er => {
            this.notifier(
              'top',
              'right',
              'danger',
              'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.'
              )
            this.toggleLoader()
          }
          )
      },
      toggleNavigation () {
        var button = event.target
        if (this.navigation) {
          button.innerHTML = '<i class="fas fa-caret-down"></i>'
          this.navigation = false
        } else {
          button.innerHTML = '<i class="fas fa-caret-up"></i>'
          this.navigation = true
        }
      },
      toggleNewPostPanel (event) {
        event.stopPropagation()
        if (document.getElementById('new-post').classList.contains('d-none')) {
          document.getElementById('new-post').classList.remove('d-none')
        } else {
          document.getElementById('new-post').classList.add('d-none')
        }
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.getPosts()
      })
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PostModules/ArchiveModules/Archives.vue